module.exports = __webpack_public_path__ + "img/Digitech360.c63c5f94.png";